module.exports = __webpack_public_path__ + "static/media/backgroundHome.dcf260ad.png";